export const mode = "PROD" // DEV/PROD
export const apiUrl =
  mode === "DEV" ? "http://127.0.0.1:4000" : "https://example.com"

export const googleAPIKeys =
  mode === "DEV"
    ? "AIzaSyBF9uq-oXr-1IQwmvTESEqdPAUk7R2yxqM"
    : "AIzaSyBF9uq-oXr-1IQwmvTESEqdPAUk7R2yxqM"

export const defaultLat = 23.8859
export const defaultLng = 45.0792

// Browser-compatible HMAC SHA256 function using Web Crypto API
export function createHmacSha256(secretKey, data) {
  try {
    const encoder = new TextEncoder()
    const keyData = encoder.encode(secretKey)
    const messageData = encoder.encode(data)

    return crypto.subtle
      .importKey("raw", keyData, { name: "HMAC", hash: "SHA-256" }, false, [
        "sign",
      ])
      .then(function (cryptoKey) {
        return crypto.subtle.sign("HMAC", cryptoKey, messageData)
      })
      .then(function (signature) {
        const hashArray = Array.from(new Uint8Array(signature))
        const hashHex = hashArray
          .map(function (b) {
            return b.toString(16).padStart(2, "0")
          })
          .join("")
        return hashHex
      })
      .catch(function (err) {
        console.error("Error creating HMAC:", err)
        return null
      })
  } catch (err) {
    console.error("Error creating HMAC:", err)
    return Promise.resolve(null)
  }
}

export function generateStrongKey() {
  const array = new Uint8Array(32)
  window.crypto.getRandomValues(array) // 32 secure random bytes

  // Convert bytes → Base64
  const binary = String.fromCharCode(...array)
  return btoa(binary)
}